<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="eight wide column">
            <Breadcrumb>
              <a v-go-back="'services'">Serviços</a>
              <i class="right chevron icon divider"></i>
              <div class="active section">{{ sectionName }}</div>
            </Breadcrumb>
          </div>
          <div v-show="persisted" class="eight wide right aligned column">
            <div class="actions">
              <a
                class="section"
                :href="$router.resolve({ name: 'newService' }).href"
              >
                <i class="plus icon"></i>Novo Serviço
              </a>
              <a @click.prevent="openHistory"
                ><i class="history icon"></i>Histórico</a
              >
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <HistoryModal ref="history" resource="Service" :item_id="form.id" />
      <form :class="['ui small', { error: anyError }, 'form']">
        <div class="ui padded grid">
          <div v-show="loading" class="ui active inverted dimmer">
            <div class="ui text loader">Carregando...</div>
          </div>
          <div class="row">
            <div class="ten wide column">
              <div
                :class="[{ error: errors.enable }, 'field']"
                :data-content="errorsTo('enable')"
              >
                <div class="ui toggle checkbox">
                  <input
                    type="checkbox"
                    id="service-form-enable"
                    name="enable"
                    v-model="form.enable"
                  />
                  <label for="service-form-enable">Serviço ativo?</label>
                </div>
              </div>
              <br />
              <div
                :class="['required', { error: errors.description }, 'field']"
                :data-content="errorsTo('description')"
              >
                <label for="service-form-description">Descrição</label>
                <input
                  type="text"
                  autofocus
                  id="service-form-description"
                  name="name"
                  v-model="form.description"
                />
              </div>
              <div
                :class="[
                  'four wide required',
                  { error: errors.measure },
                  'field'
                ]"
                :data-content="errorsTo('measure')"
              >
                <label for="service-form-measure">Unidade de medida</label>
                <select
                  id="service-form-measure"
                  name="measure"
                  v-model="form.measure"
                >
                  <option :value="null"></option>
                  <option
                    v-for="(measure, index) in measures"
                    :key="index"
                    :value="measure.value"
                  >
                    {{ measure.description }}
                  </option>
                </select>
              </div>
              <div
                :class="[{ error: errors.about }, 'field']"
                :data-content="errorsTo('about')"
              >
                <label for="service-form-obs">Observações:</label>
                <textarea
                  id="service-form-obs"
                  name="obs"
                  v-model="form.obs"
                ></textarea>
              </div>
            </div>
          </div>
          <!-- row -->
          <div class="row">
            <div class="sixteen wide column">
              <div class="ui divider"></div>
              <div class="field">
                <button
                  @click="save"
                  type="button"
                  name="save"
                  class="ui submit blue button"
                >
                  <i class="save icon"></i>Salvar
                </button>
                <a v-show="persisted" class="delete" @click.prevent="remove"
                  ><i class="trash icon"></i>Remover Serviço</a
                >
              </div>
            </div>
          </div>
        </div>
        <!-- grid -->
      </form>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import ServiceEnum from '@/enumerations/service_enum';
import HistoryModal from '@/components/history_modal';

export default {
  components: { Breadcrumb, PageLayout, HistoryModal },

  data() {
    return {
      loading: false,
      loadingCep: false,
      errors: {},
      form: {
        measure: null,
        id: null,
        description: null,
        enable: true,
        obs: null
      }
    };
  },

  computed: {
    measures() {
      return ServiceEnum.measures;
    },

    persisted() {
      return this.form.id != null;
    },

    sectionName() {
      return this.persisted
        ? `Editar Serviço - ${this.form.id}`
        : 'Novo Serviço';
    },

    anyError() {
      return !_.isEmpty(this.errors);
    }
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      if (this.$route.params.id) {
        this.fetch(this.$route.params.id);
      }
    },

    errorsTo(key) {
      const errors = _.isEmpty(this.errors[key]) ? [] : this.errors[key];
      return errors.join(', ');
    },

    _setErrors(errors) {
      this.errors = _.clone(errors);
      setTimeout(() => {
        $('.error.field').popup();
      }, 100);
    },

    openHistory() {
      this.$refs.history.open();
    },

    save() {
      this.loading = true;
      this._setErrors({});

      Api.services
        .save(this.form)
        .then(async response => {
          this.$toast.show('Serviço salvo com sucesso', 'success');
          this.form = _.clone(response.data.service);
        })
        .catch(error => {
          if (error.response) {
            const errors = error.response.data.errors;
            const baseErrors = errors && errors.base;
            if (baseErrors && baseErrors.length) {
              this.$toast.show(baseErrors.join(', '), 'error');
            } else {
              this.$toast.show('Erro ao salvar serviço', 'error');
            }
            this._setErrors(errors);
          } else {
            throw error;
          }
        })
        .finally(() => {
          this.$scrollTop();
          this.loading = false;
        });
    },

    remove() {
      const removeIt = confirm('Remover Serviço?');
      if (removeIt) {
        this.loading = true;
        Api.services
          .destroy(this.form.id)
          .then(async response => {
            this.$toast.show('Serviço removido com sucesso', 'success');
            this.$router.push({ name: 'services' });
          })
          .catch(error => {
            if (error.response) {
              const errors = error.response.data.errors;
              const baseErrors = errors && errors.base;
              if (baseErrors && baseErrors.length) {
                this.$toast.show(baseErrors.join(', '), 'error');
              } else {
                this.$toast.show('Erro ao remover serviço', 'error');
              }
              this._setErrors(errors);
            } else {
              throw error;
            }
          })
          .finally(() => {
            this.$scrollTop();
            this.loading = false;
          });
      }
    },

    fetch(id) {
      this.loading = true;
      Api.services
        .fetch(id)
        .then(async response => {
          this.form = _.clone(response.data.service);
        })
        .catch(error => {
          if (error.response) {
            this.$toast.show('Erro ao buscar serviço', 'error');
            this.$router.push({ name: 'services' });
          } else {
            throw error;
          }
        })
        .finally(() => {
          this.$scrollTop();
          this.loading = false;
        });
    }
  }
};
</script>
